export default __webpack_public_path__ + "static/media/side.6859cf79.png";